import { getOptionalLink } from "../util/link.js";
import { formatURL } from "../util/url.js";
export class RegExpMarkupRule {
    regexp;
    render;
    contexts;
    priority;
    constructor(regexp, //
    render, contexts, priority) {
        this.regexp = regexp;
        this.render = render;
        this.contexts = contexts;
        this.priority = priority;
        //
    }
    match(input, options) {
        const match = this.regexp.exec(input);
        if (match) {
            const { index, 0: { length }, } = match;
            return { index, length, ...this.render(match, options) };
        }
    }
}
export class NamedRegExpMarkupRule {
    regexp;
    render;
    contexts;
    priority;
    constructor(regexp, //
    render, contexts, priority) {
        this.regexp = regexp;
        this.render = render;
        this.contexts = contexts;
        this.priority = priority;
        //
    }
    match(input, options) {
        const match = this.regexp.exec(input);
        if (match) {
            const { index, 0: { length }, groups, } = match;
            return { index, length, ...this.render(groups, options) };
        }
    }
}
export class LinkRegExpMarkupRule {
    regexp;
    render;
    contexts;
    priority;
    constructor(regexp, //
    render, contexts, priority) {
        this.regexp = regexp;
        this.render = render;
        this.contexts = contexts;
        this.priority = priority;
        //
    }
    match(input, options) {
        const match = this.regexp.exec(input);
        if (match) {
            const { schemes, base, hosts } = options;
            const { 0: { length }, index, groups: { href, title }, } = match;
            const link = getOptionalLink(href, base, schemes, hosts);
            if (link)
                return { index, length, ...this.render(title?.trim() || formatURL(link), link, options) };
        }
    }
}
